var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wcs-product-overlay-content",
      attrs: { id: "modal_AfterPay" },
    },
    [
      _c("a", { attrs: { href: _vm.afterpayUrl, target: "_blank" } }, [
        _c("img", {
          attrs: {
            src: "https://static.afterpay.com/us-popup-medium.png",
            alt: "Afterpay info",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }